import React from 'react';
import _ from 'lodash';


const FirstStep = props => (
  <section className='simpleSlide active'  >


    {props.llamadaProformaOrTabProforma===1?
    <div className="row">
      <div className="col-md-5">
            <div className="dropdown dropdown-multi customToggle">
            <div className=' '>
            <h5 className='card-lg-title'>N° Pedidos</h5>
        </div>
              <div className="dropdown-control " data-toggle="dropdown">
                <input className="dropdown-control-input" />
                <label className="dropdown-control-fakelabel"><span></span><span className="dropdown-control-count"></span></label>
                <div className="dropdown-control-icon"><i className="ion-arrow-down-b"></i></div>
              </div>

              <div className="dropdown-tooltip dropdown-menu "   >
                <div className="dropdown-scroll">
                  <p></p>
                  <ul>
                  {
                    props.facturacionListadoCheckBox.map(element => (
                      <li key={element.numPedidoVeh}>
                      <div className="checkbox">
                      <label>
                        <input type="checkbox" checked={props.facturacionListadoSeleccionado.indexOf(element.numPedidoVeh)>=0} />
                        <div className="checkbox-skin" onClick={() =>  props.removeItems(element.numPedidoVeh)}></div>{element.numPedidoVeh}
                      </label>
                      </div>
                    </li>
                    ))
                  }
                  </ul>
                </div>
              </div>
            </div>
      </div>
    </div>
    :null}

        <div id='solicfacPedInfo' >

          {props.listProformaOrTabProforma.length>0?(
          props.pedidos.map((row,i)=>
            <div key={i}  >

            <div className='pillSelct-pills'>
              {
                props.facturacionListadoSeleccionado.filter(entry => (row.numPedidoVeh.indexOf(entry)>=0)).map((pedido, idPedido) => (
                  <label key={idPedido} className='pill pill-cyan pillSelct-pills-item' htmlFor='colaborador'>
                    {pedido}
                    <button
                      className='pillSelct-delete'
                      onClick={() => props.fnRemovePedidosSeleccionados(pedido)}
                    ><i className='icon ion-close pill-close' />
                    </button>
                  </label>
                ))
              }
            </div>

              <p className='labelInfo'>Cliente de facturación</p>
              <p>{`${row.codClie?row.codClie:''} - ${row.desClie}`}</p>
              <p className='labelInfo'>Solicitud de facturación para los siguientes pedidos</p>

              <div className='row mt-3'>
                <div className='col-sm-2'>
                  <div className='form-group'>
                    <p className='labelInfo'>Documento*</p>
                    {
                      props.documentos.map(documento => (
                        <div className='radio' key={documento.codTipo}>
                          <label className='radio-label'>
                            <input type='radio' name={`radioDocumento${row.codClie}`+i} value={`${documento.codTipo}-${documento.descripcion}`}
                              onClick={(event) =>props.changeRadioDocumento(event,row.codClie,row.estadoTransitoFact)}
                              defaultChecked={_.capitalize(props.getCliente(row.codClie,row.estadoTransitoFact).documento)===_.capitalize(`${documento.codTipo}-${documento.descripcion}`)} />
                            <div className='radio-skin' />{documento.descripcion}
                          </label>
                        </div>
                      ))
                    }
                  </div>
                </div>
                <div className='col-sm-4'>
                  <div className='form-group'>
                    <label className='labelInfo'>Tipo de pago*</label>
                    <div className='select'>
                      <select className='form-control' name={`radioTipoPago${row.codClie}`+i}
                        value={props.getCliente(row.codClie,row.estadoTransitoFact).tipoPago!==null?props.getCliente(row.codClie,row.estadoTransitoFact).tipoPago:''}
                        onChange={(event) =>props.changeOptionFormaPago(event,row.codClie,row.estadoTransitoFact)} >
                            <option value=''>Tipo de pago</option>
                        {
                          props.formasPago.map(forma => (
                            <option key={forma.id} value={`${forma.id}-${forma.nombre}`}>{forma.nombre}</option>
                          ))
                        }
                      </select>
                      <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                    </div><span className='error'>mensaje de error</span>
                  </div>
                </div>
                {
                  _.split(props.getCliente(row.codClie,row.estadoTransitoFact).tipoPago, '-')[0]!=='1'?(
                    <div className='col-sm-4'>
                      <div className='form-group'>
                        <label className='labelInfo'>Entidad financiera*</label>
                        <div className='select'>
                          <select name={`radioTipoPago${row.codClie}`+i} className='form-control' value={props.getCliente(row.codClie,row.estadoTransitoFact).entidadFinanciera!==null?props.getCliente(row.codClie,row.estadoTransitoFact).entidadFinanciera:''}
                            onChange={(event) =>props.changeOptionEntidadFinanciera(event,row.codClie,row.estadoTransitoFact)} >
                                <option value=''>Entidad financiera</option>
                            {
                              props.entidades.map(entidad => (
                                <option key={entidad.id} value={`${entidad.id}-${entidad.nombre}`}>{entidad.nombre}</option>
                              ))
                            }
                          </select>
                          <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                        </div><span className='error'>mensaje de error</span>
                      </div>
                    </div>
                ):null}

              </div>
            </div>
          )):null
          }
          <div className='modal-actions'><button className='btn btn-primary pull-right'
          disabled={props.listProformaOrTabProforma.length>0?false:true}
          onClick={props.nextStep}>Siguiente</button>
          </div>
        </div>


  </section>
);

export default FirstStep;



// WEBPACK FOOTER //
// ./src/pages/modals/SolicitarFacturacion/FirstStep.js